<template>
  <div class="signHomeContainer">
    <breadcrumb class="header">
      <el-breadcrumb slot="breadcrumb" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>签约管理 </el-breadcrumb-item>
      </el-breadcrumb>
    </breadcrumb>
    <!-- <Analysis>
        <p>在这里进行在线签约的管理，数据导出，发起履约等功能</p>
        <p>&nbsp;&nbsp;【发起签约】：你可以在这里发起普通合同的在线签约，已达成合作关系的金融机构还可以发起赋强合同的在线签约</p>
        <p>&nbsp;&nbsp;【申请赋强公证】：借款人可在签订完的赋强合同中申请赋强公证。</p>
        <p>&nbsp;&nbsp;【发起履约】：金融机构可在已申请完赋强公证的贷款合同后新建该合同的履约任务，进行履约管理</p>
    </Analysis> -->
    <div class="tabContainer">
      <div class="createSign cursorPointer" @click="createSign">发起签约</div>
      <div class="createSign createSignBlock cursorPointer" @click="onExport">
        下载当前结果
      </div>
      <el-tabs v-model="activeName" type="card" @tab-click="activeChange">
        <el-tab-pane
          :label="'全部（' + totalObject.allContract + '）'"
          name="allContract"
          @cancelSign="cancelSign"
        >
          <search-bar
            class="searchBarPosition"
            ref="allContractSearch"
            @searchChange="barChange"
            :listFlag="'allContract'"
          ></search-bar>
          <div class="list">
            <all-contract
              ref="allContractTable"
              @toDetail="toDetail"
              @tipPerson="tipPerson"
              @stopContract="stopContract"
              @toSignTrue="toSignTrue"
              @toLoad="downLoad"
              @deleteSign="deleteSign"
              @revokeContract="revokeContract"
              @toReject="toReject"
              @toReSign="toReSign"
              @onBatchSign="onBatchSign"
            ></all-contract>
            <pagination-customer
              @sizeChange="pageChange"
              ref="allContractPage"
              :currentPages="allContractcur"
              :listFlag="'allContract'"
            ></pagination-customer>
          </div>
        </el-tab-pane>
        <el-tab-pane
          :label="'待我签（' + totalObject.waitSign + '）'"
          name="waitSign"
        >
          <search-bar
            class="searchBarPosition"
            ref="waitSignSearch"
            @searchChange="barChange"
            :listFlag="'waitSign'"
          ></search-bar>
          <div class="list">
            <wait-sign
              ref="waitSignTable"
              @toDetail="toDetail"
              @tipPerson="tipPerson"
              @stopContract="stopContract"
              @toSignTrue="toSignTrue"
              @toLoad="downLoad"
              @toReject="toReject"
              @onBatchSign="onBatchSign"
            ></wait-sign>
            <pagination-customer
              ref="waitSignPage"
              :currentPages="waitSigncur"
              @sizeChange="pageChange"
              :listFlag="'waitSign'"
            ></pagination-customer>
          </div>
        </el-tab-pane>
        <el-tab-pane
          :label="'待他人签（' + totalObject.WaitOtherSign + '）'"
          name="WaitOtherSign"
        >
          <search-bar
            class="searchBarPosition"
            ref="WaitOtherSignSearch"
            :listFlag="'WaitOtherSign'"
            @searchChange="barChange"
          ></search-bar>
          <div class="list">
            <wait-other-sign
              ref="WaitOtherSignTable"
              @toDetail="toDetail"
              @tipPerson="tipPerson"
              @stopContract="stopContract"
              @toSignTrue="toSignTrue"
              @toLoad="downLoad"
              @revokeContract="revokeContract"
            ></wait-other-sign>
            <pagination-customer
              ref="WaitOtherSignPage"
              @sizeChange="pageChange"
              :currentPages="WaitOtherSigncur"
              :listFlag="'WaitOtherSign'"
            ></pagination-customer>
          </div>
        </el-tab-pane>
        <el-tab-pane
          :label="'已拒签（' + totalObject.rejectSign + '）'"
          name="rejectSign"
        >
          <search-bar
            @searchChange="barChange"
            class="searchBarPosition"
            ref="rejectSignSearch"
            :listFlag="'rejectSign'"
          ></search-bar>
          <div class="list">
            <reject-sign
              ref="rejectSignTable"
              @toDetail="toDetail"
              @tipPerson="tipPerson"
              @stopContract="stopContract"
              @toSignTrue="toSignTrue"
              @toLoad="downLoad"
            ></reject-sign>
            <pagination-customer
              ref="rejectSignPage"
              @sizeChange="pageChange"
              :currentPages="rejectSigncur"
              :listFlag="'rejectSign'"
            ></pagination-customer>
          </div>
        </el-tab-pane>
        <el-tab-pane
          :label="'已完成（' + totalObject.completeSign + '）'"
          name="completeSign"
        >
          <search-bar
            @searchChange="barChange"
            class="searchBarPosition"
            ref="completeSignSearch"
            :listFlag="'completeSign'"
          ></search-bar>
          <div class="list">
            <complete-sign
              @toCreatFqPerformance="toCreatFqPerformance"
              @toDetail="toDetail"
              @tipPerson="tipPerson"
              @stopContract="stopContract"
              @toSignTrue="toSignTrue"
              @toLoad="downLoad"
              @toReSign="toReSign"
              ref="completeSignTable"
            ></complete-sign>
            <pagination-customer
              ref="completeSignPage"
              @sizeChange="pageChange"
              :currentPages="completeSigncur"
              :listFlag="'completeSign'"
            ></pagination-customer>
          </div>
        </el-tab-pane>
        <el-tab-pane
          :label="'已终止（' + totalObject.endSign + '）'"
          name="endSign"
        >
          <search-bar
            @searchChange="barChange"
            class="searchBarPosition"
            ref="endSignSearch"
            :listFlag="'endSign'"
          ></search-bar>
          <div class="list">
            <end-sign
              ref="endSignTable"
              @toDetail="toDetail"
              @tipPerson="tipPerson"
              @stopContract="stopContract"
              @toSignTrue="toSignTrue"
              @toLoad="downLoad"
            ></end-sign>
            <pagination-customer
              ref="endSignPage"
              :currentPages="endSigncur"
              @sizeChange="pageChange"
              :listFlag="'endSign'"
            ></pagination-customer>
          </div>
        </el-tab-pane>
        <el-tab-pane
          :label="'签署失败（' + totalObject.failSign + '）'"
          name="failSign"
        >
          <search-bar
            class="searchBarPosition"
            ref="failSignSearch"
            @searchChange="barChange"
            :listFlag="'failSign'"
          ></search-bar>
          <div class="list">
            <fail-sign
              ref="failSignTable"
              @toDetail="toDetail"
              @tipPerson="tipPerson"
              @stopContract="stopContract"
              @toSignTrue="toSignTrue"
              @toLoad="downLoad"
              @toReject="toReject"
              @onBatchSign="onBatchSign"
            ></fail-sign>
            <pagination-customer
              ref="failSignPage"
              :currentPages="failSigncur"
              @sizeChange="pageChange"
              :listFlag="'failSign'"
            ></pagination-customer>
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane
          :label="'草稿箱（' + totalObject.draft + '）'"
          name="draft"
        >
          <search-bar
            class="searchBarPosition"
            @searchChange="barChange"
            ref="draftSearch"
            :listFlag="'draft'"
          ></search-bar>
          <div class="list">
            <draft
              ref="draftTable"
              @toDetail="toDetail"
              @tipPerson="tipPerson"
              @stopContract="stopContract"
              @getList="activeChange"
              @toLoad="downLoad"
              @deleteSign="deleteSign"
            ></draft>
            <pagination-customer
              ref="draftPage"
              :currentPages="draftcur"
              @sizeChange="pageChange"
              :listFlag="'draft'"
            ></pagination-customer>
          </div>
        </el-tab-pane> -->
      </el-tabs>
    </div>
    <reject-sign-dialog
      v-if="rejectDialogShow"
      @closeDialog="rejectDialogShow = false"
      :taskId="rejectParams.taskId"
      :contractId="rejectParams.contractId"
      @restDetail="activeChange"
      @findPaw="findPawHandler"
    ></reject-sign-dialog>
    <Dialog
      :visible="authDialogShow"
      :dialogTitle="'消息提示'"
      :width="'400px'"
      @closeDialog="authDialogShow = false"
    >
      <div class="signDialog" slot="dialog">
        <div class="authDscp">
          <p>您还没有通过实名认证，</p>
          <p>无法发起签约，请去实名认证！</p>
        </div>
        <div class="authHandlerBox">
          <div class="button cursorPointer" @click="authDialogShow = false">
            取消
          </div>
          <div class="button buttonActive cursorPointer" @click="goAuth">
            去认证
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog
      :visible="revokeDialoglShow"
      :dialogTitle="'撤销合同'"
      :width="'400px'"
      @closeDialog="revokeDialoglShow = false"
    >
      <div class="signDetailDialogWithButton" slot="dialog">
        <div class="authDscp">
          <p>是否要撤销这份合同？</p>
          <p>撤销完成后，服务费将在1-3个工作日，</p>
          <p>退回到您的账户，请注意查收！</p>
        </div>
        <div class="authHandlerBox">
          <div
            class="button buttonActive cursorPointer"
            @click="revokeDialoglShow = false"
          >
            取消
          </div>
          <div class="button cursorPointer" @click="revoke">确定</div>
        </div>
      </div>
    </Dialog>
    <Dialog
      :visible="stopDialogShow"
      :dialogTitle="'消息提示'"
      :width="'400px'"
      @closeDialog="stopDialogShow = false"
    >
      <div class="signDialog" slot="dialog">
        <div class="authDscp">
          <p>确定要终止掉这份合同吗？</p>
        </div>
        <div class="authHandlerBox">
          <div class="button cursorPointer" @click="stopDialogShow = false">
            取消
          </div>
          <div
            class="button buttonActive cursorPointer"
            @click="stopContractReq()"
          >
            确定
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog
      :visible="isHaveCreate"
      :dialogTitle="'消息提示'"
      :width="'400px'"
      :showClose="false"
      class="mealBox"
    >
      <div class="signDialog" slot="dialog">
        <div class="mealTop">
          <p>该账号无权限执行此操作，请联系管理员处理</p>
        </div>
        <div class="authHandlerBox" style="justify-content: center">
          <div class="button buttonActive cursorPointer" @click="closeCreate">
            确定
          </div>
        </div>
      </div>
    </Dialog>
    <findpaw
      v-if="forgetPassword"
      @closeDialog="forgetPassword = false"
    ></findpaw>
  </div>
</template>

<script>
import Breadcrumb from "@common/Breadcrumb.vue";
import SearchBar from "./components/signHome/SearchBar.vue";
import AllContract from "./components/signHome/AllContract.vue";
import WaitSign from "./components/signHome/WaitSign.vue";
import WaitOtherSign from "./components/signHome/WaitOtherSign.vue";
import rejectSign from "./components/signHome/RejectSign.vue";
import CompleteSign from "./components/signHome/CompleteSign.vue";
import EndSign from "./components/signHome/EndSign.vue";
import Draft from "./components/signHome/Draft.vue";
import FailSign from "./components/signHome/FailSign.vue";

import PaginationCustomer from "./components/signHome/PaginationCustomer.vue";
import storageUtil from "@lib/storageUtil.js";
import BaseApi from "@lib/baseApi.js";
import Dialog from "@common/Dialog.vue";
import Analysis from "@common/Analysis.vue";
import RejectSignDialog from "./components/initiateContract/RejectSign.vue";
import findpaw from "./components/initiateContract/findPaw.vue";
import download from "@lib/download.js";
import Util from "@lib/util.js";
import { mapGetters, mapState } from "vuex";
let moduleArr = {
  allContract: 0,
  waitSign: 1,
  WaitOtherSign: 2,
  rejectSign: 3,
  completeSign: 4,
  endSign: 5,
  draft: 6,
  failSign: 1,
};
export default {
  data() {
    return {
      activeName: "",
      authDialogShow: false,
      stopDialogShow: false,
      rejectDialogShow: false,
      revokeDialoglShow: false,
      forgetPassword: false,
      serachParamsObj: {},
      totalObject: {
        allContract: 0,
        waitSign: 0,
        WaitOtherSign: 0,
        rejectSign: 0,
        completeSign: 0,
        endSign: 0,
        failSign: 0,
        draft: 0,
        loading: false,
        isRequest: false,
        //是否需要实名认证
      },
      isGetTotalObject: false, // 是否查询过，若查询过，则下次调用列表接口则不查询个数

      contractIdS: "",
      allContractcur: 1,
      waitSigncur: 1,
      WaitOtherSigncur: 1,
      rejectSigncur: 1,
      completeSigncur: 1,
      endSigncur: 1,
      draftcur: 1,
      failcur: 1,
      isHaveCreate: false,
      curUserInfo: {},
    };
  },
  components: {
    Breadcrumb,
    SearchBar,
    AllContract,
    WaitSign,
    WaitOtherSign,
    rejectSign,
    CompleteSign,
    EndSign,
    Draft,
    PaginationCustomer,
    Dialog,
    findpaw,
    RejectSignDialog,
    Analysis,
    FailSign,
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
    ...mapState(["currentInfo"]),
    changeIdentity() {
      const roleCode = this.currentInfo.roleId || this.currentInfo.id;
      return roleCode;
    },
  },
  mounted() {
    // Util.getLocation();
    let temp = storageUtil.getSession("signHomeCurrentListFlag");
    let searchParams = {
      contractName: "",
      currentPage: 1,
      listFlag: "",
      pageSize: 10,
      signStartTimeBegin: "",
      signStartTimeEnd: "",
    };
    console.log(temp, "temp");
    if (temp === "failSign") {
      searchParams.failedSign = true;
    }
    if (temp) {
      this.activeName = temp;
      Object.assign(searchParams, storageUtil.getSession(temp));
    } else {
      this.activeName = "allContract";
      storageUtil.setSession("signHomeCurrentListFlag", "allContract");
    }
    searchParams.pageSize = searchParams.pageSize || 10;
    searchParams.currentPage = searchParams.currentPage || 1;
    this.handlerSearchParams(searchParams);
    this.showAnalysis();
  },
  created() {
    console.log(this.getUserInfo);
  },
  methods: {
    showAnalysis() {
      $(".signHome_analysis_btn").click(() => {
        $(".signHome_analysis_text").css("display", "block");
      });
      $(".signHome_analysis_text").hover(
        function () {
          // 鼠标移入时添加apply-class-hoverr类
          $(this).css("display", "block");
        },
        function () {
          // 鼠标移入时移出apply-class-hoverr类
          $(this).css("display", "none");
        }
      );
    },
    getTaskId(data, flag, all) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].actionCode === flag) {
          if (all) {
            return data[i];
          } else {
            return data[i].taskId;
          }
        }
      }
    },
    findPawHandler() {
      this.rejectDialogShow = false;
      this.forgetPassword = true;
    },
    goAuth() {
      this.$router.push("/personal/users/home");
    },
    toReject(row) {
      let taskId = this.getTaskId(row.taskList, "SIGN");
      let contractId = row.id;
      this.rejectParams = { taskId, contractId };
      this.rejectDialogShow = true;
    },

    // 重新签署
    toReSign(data) {
      //已支付，去签署,1-普通合同；2-赋强合同,4-调解赋强签署
      console.log(data, "data");
      let taskId = data.data.id;
      let contractIdS = data.data.id;
      if (data.data.type == 1) {
        this.$router.push(
          `/personal/sign/index/signature?isHandwriting=false&id=${contractIdS}&taskId=${taskId}&isReSign=1`
        );
      } else if (data.data.type == 2) {
        this.$router.push(
          `/personal/sign/signLoanIndex?isHandwriting=false&id=${contractIdS}&taskId=${taskId}&isReSign=1`
        );
      } else {
        this.$router.push(
          `/personal/sign/signMediate?isHandwriting=false&id=${contractIdS}&taskId=${taskId}&isReSign=1`
        );
      }
    },
    revokeContract(row) {
      let taskId = this.getTaskId(row.taskList, "REVOKE");
      let contractId = row.id;
      this.revokeParams = { taskId, contractId };
      this.revokeDialoglShow = true;
    },
    revoke() {
      let locationInfo = this.$store.getters.getLocation;
      BaseApi.createRpcToken(
        "/contract/revoke",
        {
          id: this.revokeParams.contractId,
          taskId: this.revokeParams.taskId,
          signLocation: locationInfo && locationInfo.location,
          signLocationAttr: locationInfo && locationInfo.LocationAttr,
        },
        "post"
      )
        .then((data) => {
          if (data.datas.success) {
            this.revokeDialoglShow = false;
            this.$message.success("撤销成功");
            this.activeChange();
          } else {
            this.$message.error("撤销失败");
          }
        })
        .catch(function (e) {
          errorLog(e);
        });
    },
    getUserInfos() {
      return BaseApi.createRpcToken("/user/v2/getUserInfo");
    },
    async toSignTrue(data) {
      this.$store.commit("showLoading", true);
      try {
        let userInfo = await this.getUserInfos();
        let curInfo = {};
        userInfo = [
          ...[userInfo.datas.person],
          ...userInfo.datas.enterpriseList,
        ];
        curInfo = userInfo.filter(
          (item) => item.userId == this.currentInfo.userId
        )[0];
        if (!curInfo.success || curInfo.authenticationStatus != 2) {
          this.authDialogShow = true;
          this.$store.commit("showLoading", false);
        } else {
          let temp = encodeURI(JSON.stringify(data.data));
          let taskId = this.getTaskId(data.data.taskList, "SIGN");
          let isCanReject = 1;
          if (data.data.contractUser.userId == this.currentInfo.userId) {
            isCanReject = 0;
          }
          this.contractIdS = data.data.id;

          // 判断是否已经支付过
          this.getContractInfo().then(
            (resData) => {
              this.$store.commit("showLoading", false);
              if (resData.datas.info.payStatus == 0) {
                //未支付，去支付
                this.$router.push({
                  path: "/personal/payment",
                  query: {
                    id: this.contractIdS,
                    flag: "Sign",
                    taskId: taskId,
                    isCanReject: isCanReject,
                    isHandwriting: false,
                    type: data.data.type,
                  },
                });
              } else {
                //已支付，去签署,1-普通合同；2-赋强合同,4-调解赋强签署
                if (data.data.type == 1) {
                  this.$router.push(
                    `/personal/sign/index/signature?isHandwriting=false&id=${this.contractIdS}&taskId=${taskId}&isCanReject=${isCanReject}`
                  );
                } else if (data.data.type == 2) {
                  this.$router.push(
                    `/personal/sign/signLoanIndex?isHandwriting=false&id=${this.contractIdS}&taskId=${taskId}&isCanReject=${isCanReject}`
                  );
                } else {
                  this.$router.push(
                    `/personal/sign/signMediate?isHandwriting=false&id=${this.contractIdS}&taskId=${taskId}&isCanReject=${isCanReject}`
                  );
                }
              }
            },
            () => {}
          );
        }
      } catch (e) {
        errorLog(e);
      }
    },
    //获取该合同支付状态
    getContractInfo() {
      return BaseApi.createRpcToken(
        "/contract/info",
        { id: this.contractIdS },
        "post"
      );
    },
    stopContract(data) {
      if (data.flag) {
        this.stopContaractParams = data;
        this.stopDialogShow = true;
      } else {
        this.stopContractReq(data);
      }
    },
    stopContractReq(data) {
      if (!this.isRequest) {
        this.isRequest = true;
        data = data || this.stopContaractParams;
        let row = data.data;
        let flag = data.flag;
        let taskItem = this.getTaskId(row.taskList, "CONFIRM", true);
        BaseApi.createRpcToken(
          " /contract/confirm",
          {
            id: row.id,
            taskId: taskItem && taskItem.taskId,
            approve: flag,
            rejectUserId:
              taskItem && taskItem.datas && taskItem.datas.rejectUserId,
          },
          "post"
        )
          .then(
            (data) => {
              if (data.datas.success) {
                this.$message.success("操作成功");
                // 此处不需要改变isRequest的值 会在getList的时候统一改变
                this.activeChange();
              } else {
                this.isRequest = false;
                this.$message.error("操作失败");
              }
              this.stopDialogShow = false;
            },
            () => {
              this.stopDialogShow = false;
              this.isRequest = false;
            }
          )
          .catch(function (e) {
            errorLog(e);
          });
      }
    },
    tipPerson(row) {
      BaseApi.createRpcToken(" /contract/remind", {
        id: row.id,
      })
        .then((data) => {
          if (data.datas.success) {
            this.$message.success("已发送提醒");
            this.activeChange();
          } else {
            this.$message.error("提醒发送失败");
          }
        })
        .catch(function (e) {
          errorLog(e);
        });
    },
    toDetail(row) {
      this.$router.push(`/personal/sign/detail?id=${row.id}`);
    },
    toCreatFqPerformance(row) {
      this.$router.push(`/personal/sign/creatFqPerformance?id=${row.id}`);
    },
    deleteSign(row) {
      if (!this.isRequest) {
        this.isRequest = true;
        BaseApi.createRpcToken(" /contract/delete", { id: row.id }, "post")
          .then(
            (data) => {
              if (data.datas.success) {
                this.activeChange();
              } else {
                this.isRequest = false;
                this.$message.error("删除失败");
              }
            },
            () => {
              this.isRequest = false;
            }
          )
          .catch(function (e) {
            errorLog(e);
          });
      }
    },
    downLoad(row) {
      BaseApi.createRpcToken("/file/download", { id: row.id })
        .then((data) => {
          if (data.datas.zipUrl) {
            try {
              var elemIF = document.createElement("iframe");
              elemIF.setAttribute("id", "startDown");
              elemIF.src = data.datas.zipUrl;
              elemIF.style.display = "none";
              if (document.getElementById("startDown")) {
                document.body.removeChild(document.getElementById("startDown"));
              }
              document.body.appendChild(elemIF);
            } catch (e) {}
            // window.open(data.datas.zipUrl);
          } else {
            this.$message.error("下载失败");
          }
        })
        .catch(function (e) {
          errorLog(e);
        });
    },
    beforeRouteLeave(to, from, next) {
      Object.keys(moduleArr).forEach((value) => {
        storageUtil.removeSessionItem(value);
      });
      storageUtil.removeSessionItem("signHomeCurrentListFlag");
      next();
    },
    activeChange(current, tag) {
      console.log(this.activeName, "activeName");
      let pageData = this.$refs[this.activeName + "Page"].getQuery();
      let barData = this.$refs[this.activeName + "Search"].getQuery();
      let searchParams = Object.assign({}, pageData, barData);
      storageUtil.setSession("signHomeCurrentListFlag", this.activeName),
        this.handlerSearchParams(searchParams);
    },
    cancelSign(item) {
      BaseApi.createRpcToken("/contract/revoke", { id: item.id }, "post")
        .then((value) => {
          this.activeChange();
        })
        .catch(function (e) {
          errorLog(e);
        });
    },
    //关闭提示弹框
    closeCreate() {
      this.isHaveCreate = false;
    },
    createSign() {
      if (this.getUserInfo.person.userId != this.getUserInfo.currentUserId) {
        BaseApi.createRpcToken("/user/v2/getUserPermission", {}, "post")
          .then((value) => {
            if (value.code == 200) {
              if (
                !value.datas.permissionList.filter(
                  (item) => item.code == "SIGN_ADD"
                ).length
              ) {
                this.isHaveCreate = true;
              } else {
                // 原发起申请页面
                // this.$router.push("/personal/sign/index");
                this.$router.push("/initiation/single");
              }
            }
          })
          .catch(function (e) {
            errorLog(e);
          });
      } else {
        this.$router.push("/personal/sign/index");
      }
    },
    barChange(data) {
      let pageData = this.$refs[this.activeName + "Page"].getQuery();
      let searchParams = Object.assign({}, data, pageData);
      this.handlerSearchParams(searchParams, true);
    },
    pageChange(data, flag) {
      let barData = this.$refs[this.activeName + "Search"].getQuery();
      let searchParams = Object.assign({}, barData, data);
      this.handlerSearchParams(searchParams);
    },
    handlerSearchParams(searchParams, flag = false) {
      console.log(searchParams, "searchParams");
      if (searchParams.listFlag === "failSign") {
        searchParams.failedSign = true;
      }
      if (
        flag &&
        (searchParams.signStartTimeBegin != "" ||
          searchParams.signStartTimeEnd != "" ||
          searchParams.batchNo)
      ) {
        //选择时间控件，从第一页开始查，
        searchParams.pageNumber = 1;
        this[this.activeName + "cur"] = Math.floor(Math.random() * 10);
      } else {
        //没有传递时间参数，从当前页查询
        searchParams.pageNumber = searchParams.currentPage;
      }
      delete searchParams.currentPage;
      searchParams.status = moduleArr[this.activeName];
      this.serachParamsObj = searchParams;
      searchParams.pageNumber ? searchParams.pageNumber : 1;

      this.getList(searchParams);
    },
    setTotal(list) {
      console.log(list, 'list');
      list.forEach((value) => {
        Object.keys(moduleArr).forEach((item) => {
          if (item === "failSign" && value.status === 9) {
            this.$set(this.totalObject, item, value.count);
          } else {
            if (value.status == moduleArr[item]) {
              this.$set(this.totalObject, item, value.count);
            }
          }
        });
      });
    },
    getList(searchParams) {
      this.isRequest = true;
      this.$store.commit("showLoading", true);

      BaseApi.createRpcToken("/contract/v2/list", {
        ...searchParams,
        withStat: this.isGetTotalObject ? false : true,
      })
        .then(
          (data) => {
            this.isRequest = false;
            this.$store.commit("showLoading", false);
            if (data.datas) {
              this.totalObject[this.activeName] = data.datas.list.totalRow;
              if (data.datas.contractCount) {
                this.isGetTotalObject = true;
                this.setTotal(data.datas.contractCount);
              }
              this.$refs[this.activeName + "Page"].setTotal(
                data.datas.list.totalRow
              );
              this.$refs[this.activeName + "Table"].setData(
                data.datas.list.list
              );
            }
          },
          () => {
            this.$store.commit("showLoading", false);
            this.isRequest = false;
          }
        )
        .catch(function (e) {
          errorLog(e);
        });
    },

    // 导出
    onExport() {
      BaseApi.createRpcToken(
        "/contract/v2/contractManagementExport",
        {
          ...this.serachParamsObj,
          pageSize: 100,
        },
        "POST",
        false,
        false,
        true,
        "blob"
      )
        .then(
          (res) => {
            download(
              new Blob([res.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              }),
              "签约管理",
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            );
          },
          () => {}
        )
        .catch(function (e) {
          errorLog(e);
        });
    },

    // 批量签署
    onBatchSign(list) {
      console.log(list, 'list')

      sessionStorage.setItem('SignMediateBatch', JSON.stringify(list));

      this.$router.push(
        `/personal/sign/signMediateBatch?isHandwriting=false&isReSign=1`
      );
    }
  },
  watch: {
    changeIdentity(val) {
      this.serachParamsObj.pageNumber = 1;
      this.getList(this.serachParamsObj);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" >
.signHomeContainer {
  min-width: 1080px;
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
  position: relative;
  .header {
    margin-bottom: 30px;
  }
  .signDetailDialogWithButton {
    height: 200px;
    width: 400px;
    box-sizing: border-box;
    background-color: white;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    padding: 0 20px;
    .authDscp {
      font-size: 14px;
      color: #646464;
      letter-spacing: 0;
      text-align: center;
      line-height: 20px;
      padding-top: 20px;
    }
    .withInput {
      width: 100%;
      text-align: left;
      .el-input__inner {
        width: 100%;
        height: 32px;
        line-height: 32px;
      }
    }
  }
  .signDialog {
    height: 200px;
    width: 400px;
    box-sizing: border-box;
    background-color: white;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    padding: 0 20px;
    .authDscp {
      font-size: 14px;
      color: #646464;
      letter-spacing: 0;
      text-align: center;
      line-height: 20px;
      padding-top: 20px;
    }
    .withInput {
      width: 100%;
      text-align: left;
      .el-input__inner {
        width: 100%;
        height: 32px;
        line-height: 32px;
      }
    }
  }
  .tabContainer {
    height: calc(100% - 65px);
    position: relative;
    .searchBarPosition {
      margin-bottom: 10px;
      overflow: hidden;
    }
    .el-tabs {
      height: 100%;
    }
    .dataBox {
      overflow-x: auto;
      .mainColor {
        color: #e88078;
      }
      .el-table {
        min-width: 1080px;
      }
      .cellCustomer {
        height: 32px;
        text-align: center;
        line-height: 32px;
        padding: 0;
        color: #969696;
        .revoke {
          color: #969696;
          .icon {
            width: 14px;
            background: url(./../../../assets/images/personalSignHome/cancel01_icon_nor.png.png);
            background-size: 100% 100%;
          }
          &:hover {
            .icon {
              width: 14px;
              background: url(./../../../assets/images/personalSignHome/cance01l_icon_hov_pre.png);
              background-size: 100% 100%;
            }
            color: #e88078;
          }
        }
        .reject {
          color: #969696;
          .icon {
            background: url(./../../../assets/images/personalSignHome/refusal02_icon_nor.png.png);
            background-size: 100% 100%;
          }
          &:hover {
            .icon {
              background: url(./../../../assets/images/personalSignHome/refusal02_icon_hov_pre.png.png.png);
              background-size: 100% 100%;
            }
            color: #e88078;
          }
        }
        .continueSign {
          color: #969696;
          .icon {
            background: url(./../../../assets/images/personalSignHome/details_icon_nor.png);
            background-size: 100% 100%;
          }
          &:hover {
            .icon {
              background: url(./../../../assets/images/personalSignHome/details_icon_hov.png);
              background-size: 100% 100%;
            }
            color: #e88078;
          }
        }
        .tip {
          color: #969696;
          .icon {
            background: url(./../../../assets/images/personalSignHome/remind_icon_nor.png);
            background-size: 100% 100%;
          }
          &:hover {
            .icon {
              background: url(./../../../assets/images/personalSignHome/remind_icon_hov.png);
              background-size: 100% 100%;
            }
            color: #e88078;
          }
        }
        .goSign {
          color: #969696;
          .icon {
            background: url(./../../../assets/images/personalSignHome/sign_icon_nor.png);
            background-size: 100% 100%;
          }
          &:hover {
            .icon {
              background: url(./../../../assets/images/personalSignHome/sign_icon_hov.png);
              background-size: 100% 100%;
            }
            color: #e88078;
          }
        }
        .delete {
          color: #969696;
          .icon {
            background: url(./../../../assets/images/personalSignHome/delete_icon_nor.png);
            background-size: 100% 100%;
          }
          &:hover {
            .icon {
              background: url(./../../../assets/images/personalSignHome/delete_icon_hov.png);
              background-size: 100% 100%;
            }
            color: #e88078;
          }
        }
        .download {
          color: #969696;
          .icon {
            background: url(./../../../assets/images/personalSignHome/down_icon_nor.png);
            background-size: 100% 100%;
          }
          &:hover {
            .icon {
              background: url(./../../../assets/images/personalSignHome/down_icon_hov.png);
              background-size: 100% 100%;
            }
            color: #e88078;
          }
        }
        .detail {
          color: #969696;
          .icon {
            background: url(./../../../assets/images/personalSignHome/details_icon_nor.png);
            background-size: 100% 100%;
          }
          &:hover {
            .icon {
              background: url(./../../../assets/images/personalSignHome/details_icon_hov.png);
              background-size: 100% 100%;
            }
            color: #e88078;
          }
        }
        .break {
          color: #969696;
          .icon {
            background: url(./../../../assets/images/personalSignHome/suspe_icon_nor.png);
            background-size: 100% 100%;
          }
          &:hover {
            .icon {
              background: url(./../../../assets/images/personalSignHome/suspe_icon_hov.png);
              background-size: 100% 100%;
            }
            color: #e88078;
          }
        }
        .icon {
          display: inline-block;
          height: 14px;
          width: 12px;
          vertical-align: middle;
          margin-right: 7px;
        }
        .twoLine {
          text-align: left;
        }
      }
      .headerCellCustomer {
        color: #505050;
        background-color: #f9f9f9;
      }
      .handlerBox {
        display: flex;
        justify-content: space-between;
      }
      .handlerBoxCenter {
        display: flex;
        justify-content: space-around;
        align-items: center;
      }
      .tableFooter {
        text-align: right;
        padding-right: 48px;
        color: #646464;
      }
    }
    .createSign {
      position: absolute;
      width: 100px;
      height: 30px;
      line-height: 32px;
      right: 0;
      top: 0;
      border: 1px solid #e29999;
      font-size: 12px;
      color: #e29999;
      text-align: center;
      z-index: 2;
      &.createSignBlock {
        background-color: #d81212;
        color: #ffffff;
        right: 116px;
      }
    }
    .el-tabs__item {
      height: 33px;
      line-height: 30px;
      font-size: 12px;
      color: #646464;
      background: #f5f5f5;
      border-top: 3px solid #f5f5f5;
    }
    .el-tabs__header {
      margin-bottom: 0;
    }
    .el-tabs__item:hover {
      color: #e88078;
    }
    .el-tabs--card > .el-tabs__header {
      border-bottom: 1px solid #e4e8eb;
    }
    .el-tabs__item.is-active {
      color: #e88078;
      background-color: #ffffff;
      border-top: 3px solid #e88078;
    }
    .el-tabs__content {
      box-sizing: border-box;
      border: 1px solid #e4e8eb;
      border-top: none;
      padding: 10px;
      height: calc(100% - 40px);
      overflow-y: auto;
      .el-tab-pane {
        height: 100%;
        .list {
          height: calc(100% - 40px);
          overflow-y: auto;
        }
      }
    }
  }
}
</style>
